// extracted by mini-css-extract-plugin
export var acitonButtons = "_gl-0";
export var additionalIcon = "_gl-f";
export var block = "_gl-1";
export var blockContent = "_gl-7";
export var blockDescription = "_gl-8";
export var blockIcon = "_gl-9";
export var blockTitle = "_gl-6";
export var border = "_gl-a";
export var center = "_gl-l";
export var edge = "_gl-b";
export var edgeLabel = "_gl-c";
export var edgePath = "_gl-d";
export var error = "_gl-e";
export var flowchart = "_gl-g";
export var flowchartContent = "_gl-h";
export var highlighted = "_gl-3";
export var hover = "_gl-4";
export var icon = "_gl-i";
export var left = "_gl-m";
export var navButton = "_gl-j";
export var navButtons = "_gl-k";
export var right = "_gl-n";
export var selected = "_gl-2";
export var small = "_gl-5";